import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { selectUserType } from '../../../../layout/store/slice'
import { PopupUpgrade } from '../../../../userManagement/subscriptionPayment/common/popupUpgrade'
import { USER_TYPE } from '../../../../utils/authorization'
import { TitleComponent } from '../../../common/html/TitleComponent'
import { TranslateExpiryDay } from '../../../common/text/TranslateCustom'
import { expiryDate } from '../helper'
import { getDataCurrentPlan } from '../store/slice'
import { TrialListPopup } from './TrialListPopup'

export const Header = () => {
  const data = useSelector(getDataCurrentPlan)
  const userType = useSelector(selectUserType)

  const [isShowTrial, setShowTrial] = useState(false)
  const [isShow, setShow] = useState(false)

  const handleOpenTrialList = () => {
    setShowTrial(true)
  }

  const handleClose = () => {
    setShowTrial(false)
  }

  const upgradeAccount = () => {
    setShow(true)
  }

  return (
    <>
      <div className="flexColumn gap1">
        <TitleComponent
          title="dashboard.currentPlan.title"
          style={{ whiteSpace: 'nowrap' }}
        />
        <Element>
          <TranslateExpiryDay count={expiryDate(data?.endDate)} />
        </Element>
      </div>
      <div
        className="dFlex justifyContentBetween alignItemsCenter flexWrap"
        style={{ padding: '2px 0px' }}
      >
        <Element
          className="dFlex alignItemsCenter "
          style={{
            color: '#3DA967',
            gap: 6,
          }}
        >
          <Icon className="icon-tick-circle-fill" style={{ fontSize: 13 }} />
          <Element elementName="span" className="fw600">
            {data?.dataPackageCode}
            {userType?.userTypeId === USER_TYPE.TRIAL && (
              <Element
                className="dInline"
                style={{ color: '#2C73E8' }}
                onClick={handleOpenTrialList}
              >
                {' '}
                |{' '}
                <Translate
                  value="dashboard.currentPlan.seeCompany"
                  className="cursorPointer"
                />
              </Element>
            )}
          </Element>
        </Element>
        {userType.userTypeId !== USER_TYPE.PREMIUM && (
          <>
            <Element
              className="cursorPointer"
              style={{
                padding: '3px 8px',
                backgroundColor: '#FFCD60',
                color: '#191D25',
                borderRadius: 4,
                margin: '6px 0',
              }}
              onClick={upgradeAccount}
            >
              <Translate
                value="dashboard.currentPlan.upgrade"
                className="fw600"
              />
            </Element>

            <>
              {isShow && <PopupUpgrade isShow={isShow} setIsShow={setShow} />}
            </>
          </>
        )}
      </div>
      {isShowTrial && (
        <TrialListPopup isShow={isShowTrial} handleClose={handleClose} />
      )}
    </>
  )
}
